import { createContext, useContext, useState, ReactNode } from "react";

type ApiState<T = any> = {
  loading: boolean;
  response: T | null;
  error?: any;
};

type ApiContextType = {
  states: Record<string, ApiState>;
  setState: (key: string, state: Partial<ApiState>) => void;
};

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const ApiProvider = ({ children }: { children: ReactNode }) => {
  const [states, setStates] = useState<Record<string, ApiState>>({});

  const setState = (key: string, state: Partial<ApiState>) => {
    setStates((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        ...state,
      },
    }));
  };

  return (
    <ApiContext.Provider value={{ states, setState }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApiContext = () => {
  const context = useContext(ApiContext);
  if (!context)
    throw new Error("useApiContext must be used within ApiProvider");
  return context;
};
